import { render, staticRenderFns } from "./MarketForm.vue?vue&type=template&id=2b3e8fc0&scoped=true&"
import script from "./MarketForm.vue?vue&type=script&lang=js&"
export * from "./MarketForm.vue?vue&type=script&lang=js&"
import style0 from "./MarketForm.vue?vue&type=style&index=0&id=2b3e8fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e8fc0",
  null
  
)

export default component.exports